import React, {useEffect, useState} from 'react';

// redux
import { useSelector, useDispatch, } from 'react-redux';
import { selectOneRetailer } from '_redux/slices/marketplace/retailer';
import Marketplace from '../marketplace';

const RetailerNavigation = (props) => {

    const retailer = useSelector(selectOneRetailer);

    console.log('retailer', retailer);

    return (
        <Marketplace />
    );
};

export default RetailerNavigation;
